import { MatPaginatorIntl } from '@angular/material/paginator';

export const customPaginator = () => {
  const customPaginatorIntl = new MatPaginatorIntl();

  customPaginatorIntl.itemsPerPageLabel = '';

  return customPaginatorIntl;
};
